import { useTranslation } from 'react-i18next';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import ThemedParagraph from 'verify/components/ThemedParagraph';
import ThemedTitle from 'verify/components/ThemedTitle';
import FormPhoneNumber from 'verify/forms/FormPhoneNumber';
import { MIN_HEIGHTS } from 'verify/styles/variables';

const Header = styled('div')`
  min-height: ${MIN_HEIGHTS.header};
  margin-bottom: ${SPACINGS.base * 4}px;
`;

const FormSection = styled('div')`
  margin-bottom: ${SPACINGS.base * 4}px;
`;

interface VerifyPhoneNumberPromptViewProps {
  defaultCountry: string;
  handleSubmit: (values: any) => void;
  onCountryChange: (countryCode: string) => void;
}

export default function VerifyPhoneNumberPromptView(props: VerifyPhoneNumberPromptViewProps) {
  const [t] = useTranslation();

  return (
    <div>
      <Header>
        <ThemedTitle>{t('phone-number.title')}</ThemedTitle>
        <ThemedParagraph>{t('phone-number.prompt.prompt')}</ThemedParagraph>
      </Header>
      <FormSection>
        <FormPhoneNumber
          defaultCountry={props.defaultCountry}
          labelContinue={t('phone-number.prompt.btn-submit')}
          onSubmit={props.handleSubmit}
          onCountryChange={props.onCountryChange}
        />
      </FormSection>
    </div>
  );
}
